import React, { useState } from "react";
import "./SearchBarHome.css";
import { useTranslation } from "react-i18next";

function SearchBarHome(props) {
  const [input, setInput] = useState("");
  const handleSearch = () => {
    props.setSearchTerm(input);
  };
  const { t } = useTranslation();

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder={t("searchBarbn.placeholder")}
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button onClick={handleSearch}>{t("searchBarbn.button")}</button>
    </div>
  );
}

export default SearchBarHome;
